<div class="c-modal c-modal--sm">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
                    <p class="c-modal__title c-text c-text--xl">{{ 'Modal.Title.Consents_Updated' | translate }}</p>
                </div>
			</div>
		</div>
		<div class="c-modal__content">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<p class="c-text u-osb-md">{{ 'Modal.Content.General_Consent_Updated' | translate }}</p>
				<p class="c-text"><a id="tosLink" href="{{ vm.webTosLink }}" target="_blank">{{ 'Modal.Content.General_Consent_ToS_Link' | translate }}</a></p>
				<p class="c-text"><a id="ppLink" href="{{ vm.webPPLink }}" target="_blank">{{ 'Modal.Content.General_Consent_PP_Link' | translate }}</a></p>
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
						<button id="submitButton" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.handleModalSubmit()" [disabled]="vm.processing">{{ 'Common.Accept' | translate }}</button>
					</div>
				</div>
				<loader-overlay *ngIf="vm.processing"></loader-overlay>
			</div>
		</div>
	</div>
</div>
